import { useAuth0 } from "@auth0/auth0-react"
import { Navigate, useLocation } from "react-router-dom"
import { LogIn } from "lucide-react"
import { cn } from "@/lib/utils"
import { getAppLogo } from "@/lib/ui/getAppLogo"

export function SignInPage() {
  const { loginWithRedirect, isLoading, isAuthenticated } = useAuth0()
  const location = useLocation()

  // AuthGate preserves the original path in location.state.from
  const returnTo = (location.state as { from?: string })?.from || "/companies"

  // If already authenticated (e.g., after Auth0 callback redirect), go to app
  if (isAuthenticated && !isLoading) {
    return <Navigate to={returnTo} replace />
  }

  async function handleSignIn() {
    try {
      await loginWithRedirect({ appState: { returnTo } })
    } catch (e) {
      console.error("[auth0] loginWithRedirect failed", e)
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="mx-auto max-w-md space-y-6 text-center">
        <div className="flex justify-center">
          <img src={getAppLogo()} alt="HPS" className="h-10 w-10" />
        </div>

        <h1 className="text-2xl font-semibold tracking-[-0.01em]">Sign In</h1>

        <p className="text-sm leading-6 text-muted-foreground">
          Welcome to HPS. Please sign in to continue.
        </p>

        <button
          className={cn(
            "inline-flex items-center gap-2 rounded-md bg-primary px-6 py-3 text-sm font-medium text-primary-foreground",
            "hover:bg-primary/90 disabled:opacity-50"
          )}
          onClick={handleSignIn}
          disabled={isLoading}
        >
          <LogIn className="h-4 w-4" />
          {isLoading ? "Loading..." : "Sign in with Auth0"}
        </button>
      </div>
    </div>
  )
}
